﻿import { createFileRoute } from "@tanstack/react-router";
import { AjustesEstoquesMainPage } from "@/paginas/pg_franquia/franquia-ajustes-estoques-main";

export const Route = createFileRoute("/_authenticated/franquia-ajustes-estoques-main")({
  head: () => ({
    meta: [
      { title: "Ajustes de estoques — Milky Moo Palmares" },
      {
        name: "description",
        content: "Central de ajustes manuais de cada estoque ativo do sistema.",
      },
      { property: "og:title", content: "Ajustes de estoques — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Central de ajustes manuais de cada estoque da sorveteria.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: AjustesEstoquesMainPage,
});
